import React from "react";
import "./Developer.css";
import ImageLoader from "../common/ImageLoader";
import vijayImage from "./Vijay.jpeg";
import { FaGithub, FaInstagram, FaLinkedin, FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { FaLocationDot } from "react-icons/fa6";

const Developer = () => {
  return (
    <section className="dev-resume-container">
      <div className="dev-inner">
        {/* Section Header */}
        <div className="section-header">
          <span className="section-tag">✦ LEAD DEVELOPER</span>
          <h1 className="section-main-title">Developer Profile</h1>
        </div>

        {/* Profile Card */}
        <div className="dev-main-card glass-panel">
          <div className="dev-grid">
            <div className="dev-left">
              <div className="dev-header-info">
                <h2 className="dev-name">CHINNI VIJAY KUMAR</h2>
                <span className="dev-title">
                  Full Stack Developer • Cyber Security &amp; AI Enthusiast
                </span>
              </div>

              <div className="dev-bio">
                <p>
                  A passionate full stack developer and cybersecurity enthusiast
                  focused on architecting high-performance, accessible, and
                  visually captivating web experiences.
                </p>
                <p>
                  Experienced with ReactJS, Node.js, Express, Sequelize ORM, MySQL,
                  and modern API integrations. Committed to engineering clean,
                  secure, and scalable digital solutions.
                </p>
              </div>

              {/* Social & Contact Badges */}
              <div className="dev-contact-grid">
                <a
                  href="https://github.com/Lucifer-FallenAngel"
                  target="_blank"
                  rel="noreferrer"
                  className="dev-social-badge github"
                >
                  <FaGithub />
                  <span>GitHub</span>
                </a>
                <a
                  href="http://www.linkedin.com/in/vijay-kumar-chinni-6aa9352b4"
                  target="_blank"
                  rel="noreferrer"
                  className="dev-social-badge linkedin"
                >
                  <FaLinkedin />
                  <span>LinkedIn</span>
                </a>
                <a
                  href="https://www.instagram.com/ch.vijay2412?igsh=YnpnaWllNWRiMzlr"
                  target="_blank"
                  rel="noreferrer"
                  className="dev-social-badge instagram"
                >
                  <FaInstagram />
                  <span>Instagram</span>
                </a>
                <a
                  href="mailto:vijaykumarchinni24122004@gmail.com"
                  className="dev-social-badge email"
                >
                  <MdEmail />
                  <span>Email Me</span>
                </a>
                <a href="tel:+919966798059" className="dev-social-badge phone">
                  <FaPhoneAlt />
                  <span>+91 9966798059</span>
                </a>
                <div className="dev-social-badge location">
                  <FaLocationDot />
                  <span>Visakhapatnam, AP</span>
                </div>
              </div>
            </div>

            <div className="dev-right">
              <div className="dev-photo-frame">
                <ImageLoader
                  src={vijayImage}
                  alt="CHINNI VIJAY KUMAR"
                  className="dev-photo"
                />
                <div className="photo-corner-accent top-left"></div>
                <div className="photo-corner-accent bottom-right"></div>
              </div>
            </div>
          </div>
        </div>

        {/* Website Tech Stack Card */}
        <div className="dev-tech-card glass-panel">
          <h3 className="tech-section-title">
            <i className="fas fa-layer-group"></i> Architecture &amp; Tech Stack
          </h3>
          <p className="tech-desc">
            The <strong>DIET ACM Student Chapter</strong> web portal was engineered
            using modern full-stack web technologies to deliver seamless performance,
            real-time content management, and mobile accessibility:
          </p>

          <div className="tech-features-grid">
            <div className="feature-box">
              <i className="fab fa-react feature-icon cyan"></i>
              <h4>React Frontend</h4>
              <p>Modular component architecture with interactive state management.</p>
            </div>
            <div className="feature-box">
              <i className="fab fa-node-js feature-icon green"></i>
              <h4>Node &amp; Express API</h4>
              <p>Robust REST API architecture supporting authenticated file uploads.</p>
            </div>
            <div className="feature-box">
              <i className="fas fa-database feature-icon blue"></i>
              <h4>Sequelize &amp; MySQL</h4>
              <p>Relational database modeling with automated data syncing.</p>
            </div>
            <div className="feature-box">
              <i className="fas fa-calendar-alt feature-icon purple"></i>
              <h4>Dynamic Event Hub</h4>
              <p>Live calendar, auto-rotating hero slides, and announcement system.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Developer;
